import { useReducer } from 'react';

export default initialState => {
    return useReducer((previousState, nextState) => ({ ...previousState, ...nextState }), {
        ...initialState
    });
};



// WEBPACK FOOTER //
// ./data/common/useSetState.js